<div class="row">
  <app-headertext text="Admin - Objekttyper - Objekttype"></app-headertext>
  <div class="fill-space"></div>
  <button
    mat-button
    (click)="deleteObjecttypeConfirm()"
    class="header-row-button"
  >
    <mat-icon color="warn">delete</mat-icon>
    Slett objekttype
  </button>
</div>

<div style="margin: 0 15px 0 15px;">
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</div>

<div *ngIf="objecttype && !isLoading">
  <div class="row child-margin">
    <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
    <div class="maxwidth">
      <h2>
        {{ objecttype.name }}
        <p-tag
          *ngIf="objecttype.active === false"
          icon="pi pi-ban"
          severity="danger"
          value="Deaktivert">
        </p-tag>
      </h2>
      <mat-card class="child-margin">
<!--        <div class="row" *ngIf="objecttype.name">-->
<!--          Navn:-->
<!--          <div class="fill-space"></div>-->
<!--          <div>{{ objecttype.name }}</div>-->
<!--        </div>-->

<!--        <mat-divider [inset]="true"></mat-divider>-->

        <div class="row" *ngIf="objecttype.name">
          Engelsk navn:
          <div class="fill-space"></div>
          <div>{{ objecttype.enName }}</div>
          <div *ngIf="editEnName">
            <form [formGroup]="FormEnName">
              <div class="row">
                <mat-form-field>
                  <input
                    cdkFocusInitial
                    matInput
                    id="enName"
                    type="text"
                    placeholder="Tekst"
                    formControlName="enName"
                  />
                  <mat-error *ngIf="enName.touched && enName.invalid">
                    <div *ngIf="!enName.errors.required">
                      Please enter a object type name
                    </div>
                    <div *ngIf="enName.errors.required">
                      Object type name is <strong>required</strong>
                    </div>
                  </mat-error>
                </mat-form-field>
                <button
                  mat-icon-button
                  [disabled]="FormEnName.invalid"
                  *ngIf="editEnName"
                  style="padding-left: 10px;"
                  class="cursor"
                  matTooltip="Lagre endring"
                  (click)="saveEnName(enName.value)"
                >
                  <mat-icon> save</mat-icon>
                </button>
              </div>
            </form>
          </div>
          <div>
            <mat-icon
              style="margin-left: 10px;"
              class="cursor"
              [matTooltip]="editEnName ? 'Avbryt endring' : 'Endre engelsk navn'"
              (click)="toggleEditEnName()"
            >
              {{ editEnName ? "cancel" : "edit" }}
            </mat-icon>
          </div>
        </div>

        <mat-divider [inset]="true"></mat-divider>

        <div class="row" *ngIf="objecttype.name">
          Kategori:
          <div class="fill-space"></div>
          <div *ngIf="!editcategory && objecttype.category">
            {{ objecttype.category.name }}
          </div>
          <div *ngIf="editcategory">
            <app-select
              label="Objekttype"
              [selected]="objecttype.category.id"
              (value)="onSelectionChange($event)"
              [items]="objecttypecategories"
            ></app-select>
          </div>
          <div>
            <mat-icon
              style="margin-left: 10px;"
              class="cursor"
              [matTooltip]="editcategory ? 'Avbryt endring' : 'Endre kategori'"
              (click)="toggleEditCategory()"
            >{{ editcategory ? "cancel" : "edit" }}
            </mat-icon>
          </div>
        </div>

        <mat-divider [inset]="true"></mat-divider>

        <!-- Gruppe -->
        <div class="row" *ngIf="objecttype.name">
          Gruppe:
          <div class="fill-space"></div>
          <div *ngIf="!editgroup">
            {{ objecttype.group ? objecttype.group.name : "—" }}
          </div>
          <div *ngIf="editgroup">
            <app-select
              label="Gruppe"
              [selected]="objecttype.group ? objecttype.group.id : ''"
              (value)="onSelectGroup($event)"
              [items]="availableGroups"
            ></app-select>
            <div *ngIf="!objecttype.category" style="font-size: smaller; color: darkgray;">
              Velg kategori først
            </div>
          </div>
          <div>
            <mat-icon
              style="margin-left: 10px;"
              class="cursor"
              [matTooltip]="editgroup ? 'Avbryt endring' : 'Endre gruppe'"
              (click)="toggleEditGroup()"
            >{{ editgroup ? "cancel" : "edit" }}
            </mat-icon>
          </div>
        </div>

        <mat-divider [inset]="true"></mat-divider>

        <!-- Undergruppe -->
        <div class="row" *ngIf="objecttype.name">
          Undergruppe:
          <div class="fill-space"></div>
          <div *ngIf="!editsubgroup">
            {{ objecttype.subgroup ? objecttype.subgroup.name : "—" }}
          </div>
          <div *ngIf="editsubgroup">
            <app-select
              label="Undergruppe"
              [selected]="objecttype.subgroup ? objecttype.subgroup.id : ''"
              (value)="onSelectSubgroup($event)"
              [items]="availableSubgroups"
            ></app-select>
            <div *ngIf="!objecttype.group" style="font-size: smaller; color: darkgray;">
              Velg gruppe først
            </div>
          </div>
          <div>
            <mat-icon
              style="margin-left: 10px;"
              class="cursor"
              [matTooltip]="editsubgroup ? 'Avbryt endring' : 'Endre undergruppe'"
              (click)="toggleEditSubgroup()"
            >{{ editsubgroup ? "cancel" : "edit" }}
            </mat-icon>
          </div>
        </div>

        <mat-divider [inset]="true"></mat-divider>

        <!-- Status (aktiv / deaktivert) -->
        <div class="row" *ngIf="objecttype.name">
          Status:
          <div class="fill-space"></div>
          <div>
            <p-tag
              *ngIf="objecttype.active !== false"
              icon="pi pi-check"
              severity="success"
              value="Aktiv">
            </p-tag>
            <p-tag
              *ngIf="objecttype.active === false"
              icon="pi pi-ban"
              severity="danger"
              value="Deaktivert">
            </p-tag>
          </div>
          <button
            mat-button
            style="margin-left: 10px;"
            (click)="toggleActive()"
          >
            {{ objecttype.active === false ? "Aktiver" : "Deaktiver" }}
          </button>
        </div>
      </mat-card>
    </div>
    <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
  </div>
</div>

<app-checklistitems-list></app-checklistitems-list>
